import {UserModule} from "@/store/modules/user";
import {countryData} from "@/globalConstants";
import i18n from "@/lang";


const countries = countryData.map((item) => {
    return {
        key: item.code,
        value: item.code,
        label: item.name,
    }
})

export const tabs : any[] = [
    {
        key: "user",
        label: "user-form.tabs.user",
        type: "single",
        sections: [
            {
                inputs: [
                    {
                        label: 'license-form.contact.sex',
                        name: 'input_contact_sex',
                        type: 'select',
                        options: [
                            {
                                key: "male",
                                value: "male",
                                label: 'license-form.contact.sex-male'
                            },{
                                key: "female",
                                value: "female",
                                label: 'license-form.contact.sex-female'
                            },{
                                key: "other",
                                value: "other",
                                label: 'license-form.contact.sex-other'
                            }
                        ],
                        required: false,
                        rules: '',
                        path: "Sex",
                        size: 15
                    },
                    {
                        label: 'license-form.contact.initials',
                        name: 'input_license_general_contact_initials',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Initials",
                        size: 15
                    },
                    {
                        label: 'license-form.contact.first-name',
                        name: 'input_license_general_contact_first_name',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "FirstName",
                        size: 25
                    },
                    {
                        label: 'license-form.contact.infix',
                        name: 'input_license_general_contact_infix',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Infix",
                        size: 20
                    },
                    {
                        label: 'license-form.contact.last-name',
                        name: 'input_license_general_contact_last_name',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "LastName",
                        size: 25
                    },
                    {
                        label: 'license-form.contact.phone',
                        name: 'input_license_general_contact_phone',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Phone",
                        size: 50
                    },
                    {
                        label: 'license-form.contact.email',
                        name: 'input_license_general_contact_email',
                        type: 'text',
                        required: true,
                        disabled: true,
                        rules: 'email',
                        path: "Email",
                        size: 50
                    },
                    {
                        label: 'license-form.contact.role',
                        name: 'input_license_general_contact_role',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "CompanyRole",
                        size: 50
                    },
                    {
                        label: 'license-form.contact.locale',
                        name: 'input_license_general_contact_locale',
                        type: 'language',
                        required: false,
                        rules: '',
                        path: "DefaultLocale",
                        size: 50
                    },
                ]
            }
        ]
    },
    {
        key: "company",
        label: "user-form.tabs.company",
        type: "single",
        sections: [
            {
                inputs: [
                    {
                        label: 'license-form.company.name',
                        name: 'input_license_general_company_name',
                        type: 'text',
                        required: true,
                        rules: '',
                        path: "Company.Name",
                        size: 50
                    },
                    {
                        label: 'license-form.company.tax-number',
                        name: 'input_license_general_company_tax_number',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Company.TaxCode",
                        size: 50
                    },
                    {
                        label: 'license-form.company.street',
                        name: 'input_license_general_company_street',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Address.Line1",
                        size: 45
                    },
                    {
                        label: 'license-form.company.housenumber',
                        name: 'input_license_general_company_housenumber',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Address.Line2",
                        size: 25
                    },
                    {
                        label: 'license-form.company.postal-code',
                        name: 'input_license_general_company_postalcode',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Address.PostalCode",
                        size: 30
                    },
                    {
                        label: 'license-form.company.city',
                        name: 'input_license_general_company_city',
                        type: 'text',
                        required: false,
                        rules: '',
                        path: "Address.City",
                        size: 50
                    },
                    {
                        label: 'license-form.company.country',
                        name: 'input_license_general_company_country',
                        type: 'select',
                        options: countries,
                        filterable: true,
                        required: false,
                        rules: '',
                        path: "Address.Country",
                        size: 50
                    },
                ]
            }
        ]
    },
]


export const getData = async () => {
    if (UserModule.user.Email === "demo-licentie@veewar.com"){
        window.GlobalEvents.$emit("notify", {
            type: "warning",
            title: i18n.t("notifications.demo-license-can-not-be-saved.title"),
            message: i18n.t("notifications.demo-license-can-not-be-saved.message")
        });
    }
    return UserModule.user.toJSON();
}


export const onSubmit = async (formValues: any) => {
    if (formValues.Email === "demo-licentie@veewar.com"){
        window.GlobalEvents.$emit("notify", {
            type: "error",
            title: i18n.t("notifications.demo-license-can-not-be-saved.title"),
            message: i18n.t("notifications.demo-license-can-not-be-saved.message")
        });
        return false;
    }

    // Set values
    UserModule.user.set(formValues);

    // Update license
    return UserModule.user.update();
}
